import * as React from 'react';
import { RouteObject } from 'react-router-dom';

const AdminExport = React.lazy(
    () => import(/* webpackChunkName: "admin-export" */ '../../../../containers/Admin/Export')
);

export const AdminExportRoutes: RouteObject = {
    path: 'export',
    element: (
        <React.Suspense fallback={<>...</>}>
            <AdminExport />
        </React.Suspense>
    )
};
